import DIApi from './_diApi';

class SalaryScaleAPI extends DIApi {
  controllerName = 'SalaryScales';
}

export default new SalaryScaleAPI();
